<template>

	<v-container ref="scrollPane"  class="ai-cardPaneScrollTweak" fluid>
	<v-container fluid style="max-width: 1000px; mmax-height:500px;">
	
		<div class="display-1 font-weight-bold grey--text text--darken-3 pt-12">Hello {{ agile.loggedInUser.displayName }}</div>
		
		<div v-if="agile.loggedInUser.superAdmin" class="body-2 pt-4">You are pretty lucky, as Super Admin you can see absolutely all the projects!</div>
		<div v-if="agile.loggedInUser.projects.length <= 0" class="body-2 pt-4">You are not part of any projects yet.</div>

		<div v-if="agile.loggedInUser.projects.length > 0" class="body-2 pt-4 font-weight-bold" >Your projects:</div>

		<v-container fluid>

			<v-row>

				<v-col
					v-for="(project, id) in agile.loggedInUser.projects"
					:key="id"
					cols="6" sm="4" md="3"
				>
					<v-card class="mx-auto" color="secondary lighten-4">
						
						<v-card-title class="subtitle-2 secondary lighten-3 font-weight-bold">{{ project.prettyName }}</v-card-title>

						<v-card-text class="pt-3 text--primary">
							<div class="font-weight-bold">Client:</div>
							<div>{{ project.clientName }}</div>
							<div class="mt-3 font-weight-bold">Project group:</div>
							<div>{{ project.groupName }}</div>
						</v-card-text>

						<v-card-actions>
							<v-btn
								color="blue darken-4"
								text
								router :to="'/contenteditor/'+project.key"
							>
								Open project
							</v-btn>
						</v-card-actions><!--@click="setCurrentProject(project)"  -->
					</v-card>
				</v-col>
			</v-row>

		</v-container>

	</v-container>
	</v-container>
	

</template>

<script>


// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import agile from '@/shift/agile'
//import agileFb from '@/shift/agileFb';
//import { remote } from 'electron'
//const { app } = require('electron')

// ----------------------------------
//	VUE: Start default
// ----------------------------------

export default
{
	name: 'Dashboard',
	components: { },


	// ----------------------------------
	//	VUE: Data and computed
	// ----------------------------------

	data: () =>
	({

		agile: agile

	}),

	computed:
	{
       appBarHeight()
		{
			return agile.appBarHeight();
		},
    },


	// ----------------------------------------------------
    //
    //  VUE hooks: Create
    //
	// ----------------------------------------------------
	
	created()
	{
		//console.log(remote);
		if (this.$root.$updateUserProjects) this.$root.$updateUserProjects();

		this.boundOnResize = this.onResize.bind(this)
		window.addEventListener('resize', this.boundOnResize);
	},

	mounted()
	{
		this.onResize();
	},


	// --------------------------------------------------------------------
    //
    //	VUE: Methods
    //
	// --------------------------------------------------------------------

	methods:
	{
		onResize()
		{
			//console.log('resize', (window.innerHeight-this.appBarHeight)+'px')
			//console.log("::", this.$refs.scrollPane);
			this.$refs.scrollPane.style.height = (window.innerHeight-this.appBarHeight)+'px';
		},

	},

	beforeDestroy()
	{
		window.removeEventListener('resize', this.boundOnResize);
	},
	
}
</script>